import * as D from 'io-ts/lib/Decoder'

export const ArtistDecoder = D.type({
    _id: D.string,
    name: D.string,
    profileImg: D.string,
    description: D.string,
    title: D.string,
    genres: D.array(D.string),
})

export interface Artist extends D.TypeOf<typeof ArtistDecoder> {}
